export const EMAIL_CONTENT_ID = 'emailContentId';
export const RECIPIENT_EMAILS = 'recipientEmails';
export const RECIPIENT_PROPERTY = 'recipientProperty';
export const ACTION_TYPE = 'actionType';